import { css } from "lit";

export const styles = css`
  .confirmation-buttons {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-200);
    padding: var(--sds-size-space-300);

    --wow-button-inner-width: 100%;
  }
`;
